import React from "react";

const EICInput = ({ eicCode, setEicCode, onSearch }) => (
  <div className="eic-container">
    <label>Unesite EIC kod:</label>
    <input
      type="text"
      value={eicCode}
      onChange={(e) => setEicCode(e.target.value)}
      placeholder="EIC kod"
    />
    <button onClick={onSearch}>Pretraži</button>
  </div>
);

export default EICInput;